import React from "react";
import './EliminationBracket.css';
import {useGetBracket} from "./matchesHooks";
import BracketRound from "./BracketRound";

interface EliminationBracketProps {
    heatId: number;
}

const EliminationBracket: React.FC<EliminationBracketProps> = ({heatId}) => {
    const {data: bracket, isLoading, isError} = useGetBracket(heatId);

    return (
        <BracketRound matches={bracket || []}/>
        )
}

export default EliminationBracket;